import { render, staticRenderFns } from "./NotificationsDropdown.vue?vue&type=template&id=59db283a"
import script from "./NotificationsDropdown.vue?vue&type=script&lang=js"
export * from "./NotificationsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports